/* eslint-disable wrap-iife */

/* global jQuery */

// Cookies consent bar

/**
 * Class for controlling the card deck element
 */
class DispatchSkinCookiesConsentBar {

	/**
	 * Constructs the class and sets up instance variables.
	 */
	constructor() {

		this.selector = '.js-cookies-consent-bar';
		this.closerSelector = `${this.selector}__closer`;
		this.hiddenClass = 'is-hidden';
		this.cookie = 'dispatch-skin-cookie-consent=true';
		this.cookiesConsentBars = [];
	}

	/**
	 * Initializes the class, sets up events for section-based scroll animations.
	 */
	initialize() {

		this.cookiesConsentBars = jQuery( this.selector );

		if ( this.cookiesConsentBars.length ) {

			if ( document.cookie.indexOf( this.cookie ) === -1 ) {
				this.cookiesConsentBars.removeClass( this.hiddenClass );
			}

			this.events();
		}
	}

	// Events
	events() {

		// Closer click listener
		jQuery( '.site' ).one(
			'click',
			this.closerSelector,
			function( event ) {

				document.cookie = `${this.cookie}; expires=Tue, 19 Jan 2038 03:14:07 GMT; path=/`;
				jQuery( event.target ).closest( this.selector )
					.addClass( this.hiddenClass );
			}.bind( this )
		);
	}

}

const cookiesConsentBar = new DispatchSkinCookiesConsentBar();
export default cookiesConsentBar;



// WEBPACK FOOTER //
// ./src/js/inc/cookies-consent-bar.js